import React, { useState, useEffect } from 'react';
import { PhotoProvider } from 'react-photo-view';
import 'react-photo-view/dist/react-photo-view.css';
import { useLocation } from 'react-router';

import { theme, List, Space, Spin, Typography, message, Button } from 'antd';

import Configurazione from '../../Configurazione';
import { GetErrorMessage } from '../../Utility';
import api from '../../api';
import AllegatoMagazzino from '../AllegatoMagazzino';
import HeaderBar from '../HeaderBar';
import '../Magazzino.css';
import BloccoLastraCardMagCli from './BloccoLastraCardMagCli';

const { useToken } = theme;

export default function MagazzinoClientiDettaglio() {
    const { token } = useToken();
    const location = useLocation();

    const [isRunning, setIsunning] = useState(false);
    const [data, setData] = useState<any>([]);

    useEffect(() => {
        FetchData();
    }, []);

    async function FetchData() {
        try {
            setIsunning(true);

            const dt = {
                idSocieta: Configurazione().idsocieta,
                numeroBloccoFornitore: location.state.numeroBloccoFornitore,
                monolama: location.state.monolama,
            };
            const result = await api.post('Magazzino/StockCliente', dt);

            if (result?.data != null) setData(result.data);
        } catch (error) {
            message.error(GetErrorMessage(error));
        } finally {
            setIsunning(false);
        }
    }

    async function downloadFoto() {
        try {
            setIsunning(true);

            const dts = data.map((item: any) => ({
                nomeCompletoFile: item.nomeFile, // Unisco gli elementi dell'array in una stringa
                nomeOriginaleFile: item.nomefileOriginale,
                numeroBlocco: String(item.numeroBlocco),
                numeroBloccoFornitore: item.numeroBloccoFornitore,
                numeroLastra: String(item.numeroLastra),
            }));

            const res = await api.post(Configurazione().apiBaseUrl + 'Magazzino/GetFotoByListaNomi?tipo=0', dts, {
                responseType: 'blob',
            });

            if (res.status === 200) {
                const blob = await res.data;
                // Creare un oggetto URL per il blob
                const url = window.URL.createObjectURL(blob);

                // Creare un link invisibile e cliccarlo per avviare il download
                const a = document.createElement('a');
                a.style.display = 'none';
                a.href = url;
                a.download = 'foto.zip';
                document.body.appendChild(a);
                a.click();
                window.URL.revokeObjectURL(url);
            }
        } catch (error) {
            message.error(GetErrorMessage(error));
        } finally {
            setIsunning(false);
        }
    }

    return (
        <div style={{ margin: '0px' }}>
            <div style={{ marginTop: '0px', width: '100%' }}>
                <HeaderBar
                    descrizione={'Dettaglio blocco ' + data[0]?.numeroBloccoFornitore}
                    menuSelezionato="MagazzinoClienti"
                ></HeaderBar>
                <Space className="App-body" direction="vertical">
                    <div
                        style={{
                            width: '100%',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            position: 'relative',
                        }}
                    >
                        <div style={{ textAlign: 'center', width: '100%' }}>
                            <Typography.Text className="testotitolo" style={{ color: token.colorTextSecondary }}>
                                Blocco {location.state.numeroBloccoFornitore}
                                {location.state.monolama} -
                                <span style={{ color: token.colorPrimary }}> {data[0]?.qualita}</span>
                            </Typography.Text>
                            <br></br>
                            <Typography.Text style={{ color: token.colorTextSecondary, fontSize: '17px' }}>
                                Numero pezzi {data.reduce((acc: any, row: any) => row.pezzi + acc, 0)} -{' '}
                                {data.reduce((x: any, r1: any) => r1.qtaAcq + x, 0).toFixed(2)} {[data[0]?.um]}
                            </Typography.Text>
                            <hr style={{ width: '10%' }}></hr>
                            <Button onClick={downloadFoto}>Download Images</Button>
                        </div>
                        <div>
                            <AllegatoMagazzino
                                numeroBloccoFornitore={location.state.numeroBloccoFornitore}
                                codCliente={location.state.codCliente}
                                monolama={location.state.monolama}
                                numeroBlocco={location.state.numeroBlocco}
                            ></AllegatoMagazzino>
                        </div>
                    </div>
                    <Spin spinning={isRunning} size="large">
                        <PhotoProvider maskOpacity={0.9} speed={() => 500}>
                            <List
                                style={{ alignSelf: 'center', textAlign: 'center' }}
                                dataSource={data}
                                grid={{ xs: 1, sm: 2, md: 3, lg: 3, xl: 3, xxl: 3 }}
                                renderItem={(item: any) => {
                                    return (
                                        <BloccoLastraCardMagCli
                                            nomefile={item.nomeFile}
                                            qualita={item.qualita}
                                            finitura={item.finitura}
                                            numeroBloccoFornitore={item.numeroBloccoFornitore}
                                            numeroBlocco={item.numeroBlocco}
                                            monolama={item.monolama}
                                            pezzi={item.pezzi}
                                            codCliente={item.codCliente}
                                            lun={item.lunA}
                                            lar={item.larA}
                                            spessore={item.spessore}
                                            numeroLastra={item.numeroLastra}
                                            isCliente={true}
                                            um={item?.um}
                                        ></BloccoLastraCardMagCli>
                                    );
                                }}
                            ></List>
                        </PhotoProvider>
                    </Spin>
                </Space>
            </div>
        </div>
    );
}
